export default "__VITE_ASSET__Bba1KTNf__"